import Loading from '@/shared/components/Carregando';
import { DataAmigavel, DiasEntreDuasDatas } from '@/shared/utils/datas';
import { Fragment, useEffect, useState } from 'react';
import { GetRelatorioLotacoesPorEstagiarios } from './lotacoes-estagiario.service';
import { IQueryComarcas, IQueryDefensores, IQueryDefensorias, IQueryPredios } from '@/api.types';
import { TipoLotacao } from '../enums/tipo-lotacao.enum';
import { TipoPeriodoDescanso } from '../../periodo/enums/tipo-periodo-descanso.enum';
import { toast } from 'react-toastify';

interface IMyProps {
  exibirEventos: boolean;
}

// interface para tipagem na função RenderizarColunaDefensores
interface IFolga {
  periodo_tipo: TipoPeriodoDescanso;
  periodo_data_inicial: string;
  periodo_data_final: string;
  periodo_motivo: string;
}

// confere se o campo (anotação ou dado) ja foi renderizado, se já está presente na célula, evitando redundância
const renderedSet = new Set<string>();
// function jaFoiRenderizado(conteudo: string): boolean {
//   if (renderedSet.has(conteudo)) {
//     return true;
//   }
//   renderedSet.add(conteudo);
//   return false;
// }

export default function RelatorioEstagiariosContent({
  exibirEventos,
}: IMyProps) {
  const [loading, setLoading] = useState<boolean>(true);
  const [relatorio, setRelatorio] = useState<IQueryComarcas[]>([]);

  useEffect(() => {
    renderedSet.clear(); // Limpa o conjunto de renderização ao iniciar o componente
    setLoading(true);
    GetRelatorioLotacoesPorEstagiarios()
      .then((result: IQueryComarcas[]) => {
        setRelatorio(result);
        setLoading(false);
      })
      .catch((res: any) => {
        toast.error((res as string) + '');
      });
  }, [exibirEventos]);

  function RenderizarPredio(itemComarca: IQueryComarcas): JSX.Element[] {
    const elementos: JSX.Element[] = [];

    itemComarca.predios.forEach((item: IQueryPredios, index: number) => {
      elementos.push(
        <Fragment key={`comarca-${index}`}>
          <table className="table table-sm table-bordered align-middle border border-dark m-0 p-0">
            <thead>
              <tr>
                <th>
                  - {item.predio_nome}
                  <br />
                  {/* {''.concat(item.endereco_logradouro || '',

                    ', nº ', item.endereco_bairro || '',
                    '. CEP: ', item.endereco_cep || '',
                    '. ', item.endereco_cidade || '', ' - '
                  )}
                  TELEFONES: {'('.concat(item.telefoneprincipal_ddd || '', ') ', item.telefoneprincipal_numero || '')} */}
                </th>
              </tr>
              <tr className="text-end">
                <td colSpan={5} className="relatorio-estagiarios-titulovagas">
                  <span>
                    Total de estagiários na comarca:{' '}
                    {String(
                      item.defensorias.reduce(
                        (
                          accumulator: number,
                          currentValue: IQueryDefensorias,
                        ) =>
                          accumulator + (currentValue.estagiarios?.length || 0),
                        0,
                      ),
                    ).padStart(1, '0')}
                  </span>
                </td>
              </tr>
            </thead>
          </table>
          <table className="table table-sm table-bordered align-middle border border-dark text-center">
            <thead>
              <tr>
                <th style={{ width: '20%' }}>LOCAL DE ATUAÇÃO</th>
                <th style={{ width: '30%' }}>DEFENSOR</th>
                <th style={{ width: '25%' }}>SUBSTITUIÇÃO</th>
                <th style={{ width: '30%' }}>ESTAGIÁRIO(A)</th>
              </tr>
            </thead>
            <tbody>{RenderizarLinhaDeEstagiario(item)}</tbody>
          </table>
        </Fragment>,
      );
    });

    return elementos;
  }

  function RenderizarLinhaDeEstagiario(predios: IQueryPredios): JSX.Element[] {
    const elementos: JSX.Element[] = [];

    predios.defensorias.forEach(
      (defensoria: IQueryDefensorias, index: number) => {
        const maxEstagiarios = Math.max(
          defensoria.defensoria_maximo_estagiarios || 0,
          defensoria.estagiarios?.length || 0,
          1,
        );

        const estagiarios = defensoria.estagiarios || [];
        const defensorCell = (
          <td rowSpan={maxEstagiarios}>
            {RenderizarColunaDefensores(defensoria.defensores)}
          </td>
        );
        const defensoriaCell = (
          <td rowSpan={maxEstagiarios}>{defensoria.defensoria_nome}</td>
        );
        const substitutoCell = (
          <td rowSpan={maxEstagiarios}>
            {RenderizarColunaSubstitutas(defensoria)}
          </td>
        );

        // Renderização da primeira linha
        elementos.push(
          <tr key={`linha-estagiario-${index}-0`}>
            {defensoriaCell}
            {defensorCell}
            {substitutoCell}
            <td>
              {estagiarios[0] ? (
                <>
                  {estagiarios[0].estagiario_nome}
                  <br />
                  <span className="text-muted small">
                    ({DataAmigavel(estagiarios[0].lotacoes_data_inicial)} a{' '}
                    {DataAmigavel(estagiarios[0].lotacoes_data_final)}){' '}
                    {estagiarios[0].lotacoes_anotacao1} {estagiarios[0].lotacoes_anotacao2}

                  </span>
                </>
              ) : (
                '(VAGO)'
              )}
            </td>
          </tr>,
        );

        // Demais estagiários
        for (let i = 1; i < maxEstagiarios; i++) {
          elementos.push(
            <tr key={`linha-estagiario-${index}-${i}`}>
              <td>
                {estagiarios[i] ? (
                  <>
                    {estagiarios[i].estagiario_nome}
                    <br />
                    <span className="text-muted small">
                      ({DataAmigavel(estagiarios[i].lotacoes_data_inicial)} a{' '}
                      {DataAmigavel(estagiarios[i].lotacoes_data_final)})
                    </span>
                  </>
                ) : (
                  '(VAGO)'
                )}
              </td>
            </tr>,
          );
        }
      },
    );

    return elementos;
  }

  function RenderizarColunaSubstitutas(
    defensoria: IQueryDefensorias,
  ): JSX.Element | JSX.Element[] {
    if (!defensoria.substituta1_nome && !defensoria.substituta2_nome) {
      return <span>Sem Substitutos Automáticos</span>;
    }

    const elementos: JSX.Element[] = [];
    elementos.push(
      <Fragment key={`substituto-${Math.random().toString(36).substr(2, 9)}`}>
        {defensoria.substituta1_nome ? (
          <>
            <span className="fw-bold">1º SUBSTITUTO</span>
            <br />
            {defensoria.substituta1_nome}
          </>
        ) : (
          '(vago)'
        )}
        <br />
        {defensoria.substituta2_nome ? (
          <>
            <span className="fw-bold">2º SUBSTITUTO</span>
            <br />
            {defensoria.substituta2_nome}
          </>
        ) : (
          ''
        )}
      </Fragment>,
    );

    return elementos;
  }

  function getTipoExtenso(tipo: TipoPeriodoDescanso): string {
    switch (tipo) {
      case TipoPeriodoDescanso.Ferias:
        return 'Férias';
      case TipoPeriodoDescanso.FolgaNatalicia:
        return 'Folga Natalícia';
      case TipoPeriodoDescanso.AbonoTrabalhado:
      case TipoPeriodoDescanso.AbonoEspecial:
        return 'Abono';
      case TipoPeriodoDescanso.LicencaPremio:
      case TipoPeriodoDescanso.LicencaOutros:
        return 'Licença';
      case TipoPeriodoDescanso.Afastamento:
        return 'Afastamento';
      default:
        return '';
    }
  }

  function RenderizarColunaDefensores(
    defensores: IQueryDefensores[],
  ): JSX.Element[] {
    const elementos: JSX.Element[] = [];
    const conteudosRenderizados = new Set<string>();

    const titulares = defensores.filter(
      (a: IQueryDefensores) => a.lotacoes_tipo === TipoLotacao.Titularidade,
    );

    if (titulares.length === 0) {
      elementos.push(
        <Fragment key="vago">
          <span>(VAGO)</span>
          <br />
          <br />
        </Fragment>,
      );
    }

    defensores.forEach((item: IQueryDefensores, index: number) => {
      const conteudoStr = JSON.stringify({
        titulo: item.defensor_titulo,
        nome: item.defensor_nome,
        anotacao1: item.lotacoes_anotacao1,
        anotacao2: item.lotacoes_anotacao2,

        folgas: item.folgas?.map((f: IFolga) => ({
          tipo: f.periodo_tipo,
          ini: f.periodo_data_inicial,
          fim: f.periodo_data_final,
          motivo: f.periodo_motivo,
        })),
      });

      if (conteudosRenderizados.has(conteudoStr)) return;
      conteudosRenderizados.add(conteudoStr);

      elementos.push(
        <Fragment key={`defensor-${index}`}>
          <span className={`fw-bold ${!item.lotacoes_ativo ? 'relatorio-defensor-inativo' : ''}`}>
            {item.defensor_titulo} {item.defensor_nome}
          </span>
          <br />
          <span className="fst-italic relatorio-defensor-observacao">
            {item.lotacoes_anotacao1} {item.lotacoes_anotacao2}
          </span>
          <br />
          {exibirEventos && item.folgas && item.folgas.length > 0 && (
            <span className="relatorio-defensor-folga text-danger">
              {(() => {
                const folgasRenderizadas = new Set<string>();
                return item.folgas
                  .sort(

                    (a: IFolga, b: IFolga) =>
                      new Date(a.periodo_data_inicial).getTime() -
                      new Date(b.periodo_data_final).getTime(),
                  )

                  .filter((folga: IFolga) => {
                    const chave = `${folga.periodo_tipo}-${folga.periodo_data_inicial}-${folga.periodo_data_final}-${folga.periodo_motivo}`;
                    if (folgasRenderizadas.has(chave)) return false;
                    folgasRenderizadas.add(chave);
                    return true;
                  })

                  .map((folga: IFolga, i: number) => (
                    <Fragment key={`folga-${i}`}>
                      <span>
                        ({getTipoExtenso(folga.periodo_tipo)}:{' '}
                        {DataAmigavel(folga.periodo_data_inicial)} a{' '}
                        {DataAmigavel(folga.periodo_data_final)} –
                        {DiasEntreDuasDatas(
                          folga.periodo_data_inicial,
                          folga.periodo_data_final,
                        )}{' '}
                        dias – {folga.periodo_motivo})
                      </span>
                      <br />
                    </Fragment>
                  ));
              })()}
            </span>
          )}
          <br />
        </Fragment>,
      );
    });

    return elementos;
  }

  // function RenderizarColunaEstagiarios(
  //   estagiarios: IQueryEstagiarios[],
  //   maxEstagiarios: number,
  // ): JSX.Element[] {
  //   const elementos: JSX.Element[] = [];

  //   estagiarios.forEach((item: IQueryEstagiarios, index: number) => {
  //     elementos.push(
  //       <tr key={`coluna-${item.estagiario_nome.trim()}-${index}`}>
  //         <td>
  //           {item.estagiario_nome}
  //           <br />
  //           <span className="text-muted small">
  //             ({DataAmigavel(item.lotacoes_data_inicial)} a{' '}
  //             {DataAmigavel(item.lotacoes_data_final)})
  //           </span>
  //           <br />
  //         </td>
  //       </tr>,
  //     );
  //   });

  //   if (estagiarios.length < maxEstagiarios) {
  //     for (let i = estagiarios.length; i < maxEstagiarios; i++) {
  //       elementos.push(
  //         <tr key={`coluna-vago-${i}`}>
  //           <td>(VAGO)</td>
  //         </tr>,
  //       );
  //     }
  //   }

  //   return elementos;
  // }

  if (loading) return Loading();

  return (
    <Fragment>
      <div className="col-12" id="conteudo">
        <div className="text-center">
          <h4 className="text-center relatorio-font relatorio-titulo">
            DEFENSORIA PÚBLICA DO ESTADO DE SERGIPE - TABELA DE LOTAÇÃO
          </h4>
          <span className="text-center ft-small">
            SUBDEFENSORIA - REVISADA EM{' '}
            <input
              title="Data"
              type="text"
              className="form-control-plaintext"
              style={{ width: '10%', display: 'inline' }}
              defaultValue={DataAmigavel(new Date())}
            />
          </span>
        </div>
        <br />

        {relatorio &&
          relatorio.map((item: IQueryComarcas, index: number) => (
            <div key={index} className="relatorio">
              <h5 className="relatorio-estagiarios-comarca">
                {item.comarca_nome}
              </h5>
              {RenderizarPredio(item)}
            </div>
          ))}
      </div>
    </Fragment>
  );
}